var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ApiLoadingController',{attrs:{"fetch":_vm.fetch,"params":_vm.params},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var data = ref.data;
return [_c('VodStatusIndicator',{attrs:{"status":data.status,"match_id":_vm.matchId}})]}},{key:"loading",fn:function(){return [_c('Loading',{attrs:{"label":""}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }